import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  makeRequestUrl: (host, projectID) => {
    return `${host}/security/${projectID}/get_secret_formats`
  },
  checkRequiredArguments: () => {},
  makeResponseData: (json) => {
    return json ?? []
  }
}
export default createFetcher(fetcherConfiguration)
